const monthsMapper = [
  'январе',
  'феврале',
  'марте',
  'апреле',
  'мае',
  'июне',
  'июле',
  'августе',
  'сентябре',
  'октябре',
  'ноябре',
  'декабре',
];

export function prepareRateTitleByDate(initTitle: string) {
  const currentMonth = new Date().getMonth();

  return monthsMapper.reduce((acc, key) => {
    if (initTitle.includes(key)) {
      return initTitle.replace(key, monthsMapper[currentMonth]);
    }

    return acc;
  }, initTitle);
}
